import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TradingOperationType } from "@gql/offer";

@Component({
	selector: "transaction-pending-ribbon",
	templateUrl: "./transaction-pending-ribbon.component.html",
	styleUrls: ["./transaction-pending-ribbon.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TransactionPendingRibbonComponent {
	@Input() pendingTrades: TradingOperationType[] = [];
}
